export default __webpack_public_path__ + "323bbc0bd86ebdb02e35f60a23480efe.png";